import {
  AloftDate,
  AloftPrice,
  SubjectData,
  isDefined,
  orUndefined,
  schAloftArea,
} from '@aloft/toolkit-shared';

import { InitialCompSearch } from '../types.ts';

const glaThresholdMult = 0.2;

export const getDefaultRecommendedCompSearch = (
  subject: SubjectData,
  effectiveDate: AloftDate,
): InitialCompSearch['body']['search'] => {
  const gla = orUndefined((v) => schAloftArea.parse(v))(subject.editableData.improvements.gla);
  const { age } = subject.editableData.improvements;

  let glaMin;
  let glaMax;
  if (isDefined(gla)) {
    const glaThreshold = gla.mul(glaThresholdMult);
    glaMin = gla.sub(glaThreshold);
    glaMax = gla.add(glaThreshold);
  }

  let yearBuiltRange;
  if (isDefined(age) && age < 10) {
    const yearBuiltMax = effectiveDate.getYear();
    const yearBuiltMin = yearBuiltMax - 20;
    yearBuiltRange = {
      max: yearBuiltMax,
      min: yearBuiltMin,
    };
  }

  const maxSaleDate = effectiveDate;

  return {
    filters: {
      propertySubType: subject.editableData.improvements.propertyType,
      saleDate: {
        max: maxSaleDate,
        min: maxSaleDate.subtractMonths(12),
      },
      gla: {
        max: glaMax,
        min: glaMin,
      },
      lotSize: {
        max: undefined,
        min: undefined,
      },
      yearBuilt: yearBuiltRange,
      salePrice: {
        min: AloftPrice.fromUnitAmount(1000000),
        max: undefined,
      },
    },
    geoSearch: {
      t: 'polygon',
      coords: [],
    },
    matchCriteria: {
      saleDate: 'min_max_range',
      salePrice: 'min_max_range',
      gla: 'min_max_range',
      lotSize: 'min_max_range',
      yearBuilt: 'min_max_range',
      bedrooms: 'min_max_range',
      fullBaths: 'min_max_range',
      stories: 'min_max_range',
      garageSpaces: 'min_max_range',
    },
  };
};
